import {
  DashboardData,
  DashboardHomeScope,
} from "@/domain/entity/dashboard/dashboard-entity";
import { DashboardRepository } from "@/domain/repository/dashboard-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

type FetchDashboardInput = {
  scope?: DashboardHomeScope;
};

export class FetchDashboardUsecase {
  constructor(private readonly dashboardRepo: DashboardRepository) {}

  async execute(input?: FetchDashboardInput): Promise<SATResult<DashboardData, SATError>> {
    return this.dashboardRepo.fetchDashboard(input?.scope);
  }
}
